import axios from "axios";
import Vue from "vue";
import globalMethods from '@/globalMethods/';

Vue.use(globalMethods);

export default () => {
    let headersToUse = {
        "Accept": "*/*",
        "Content-Type": "application/json",
    };
    // let token =  sessionStorage.getItem("token");
    let token =  Vue.prototype.$getCookie("access_token");

    if(token) {
        headersToUse.Authorization = "Bearer "+token;
    }

    return axios.create({
        baseURL: process.env.VUE_APP_BASE_URL,
        withCredentials: false,
        headers: headersToUse
    });
};